import axios from 'axios';
const API_URL = process.env.REACT_APP_API;

export async function getAccountStatment(filters: any) {
  const params = new URLSearchParams();
  if (filters.user_id) params.set('user_id', filters.user_id);
  if (filters.init_date) params.set('init_date', filters.init_date);
  if (filters.end_date) params.set('end_date', filters.end_date);
  if (filters.rol_id) params.set('rol_id', filters.rol_id);
  const response = await axios.get(
    `${API_URL}reports/account_statement?${params.toString()}`
  );
  const data = response.data.doc.data.rows;
  return data;
}

export async function downloadPDF(filters: any) {
  const date = new Date().toISOString().split('T')[0];

  // Construcción de parámetros
  const params = new URLSearchParams();
  params.append('sort', 'id');
  if (filters.user_id && filters.user_id !== 0) {
    params.append('user_id', filters.user_id.toString());
  }
  if (filters.init_date) params.append('init_date', filters.init_date);
  if (filters.end_date) params.append('end_date', filters.end_date);
  if (filters.codeAccount) params.append('codeAccount', filters.codeAccount);

  try {
    const response = await axios.get(
      `${API_URL}reports/account_statement/document/pdf?${params.toString()}`,
      { responseType: 'blob' }
    );

    const blob = new Blob([response.data], { type: 'application/pdf' });
    const url = window.URL.createObjectURL(blob);
    const link = document.createElement('a');
    link.href = url;
    link.setAttribute('download', `REPORTE-ESTADO-DE-CUENTA-${date}.pdf`);
    document.body.appendChild(link);
    link.click();

    setTimeout(() => {
      document.body.removeChild(link);
      window.URL.revokeObjectURL(url);
    }, 1000);

    return true;
  } catch (error: any) {
    if (error.response?.data instanceof Blob) {
      const errorText = await error.response.data.text();
      return JSON.parse(errorText);
    }
    return { message: 'Error inesperado' };
  }
}

export async function downloadExcel(filters: any) {
  const date = new Date().toISOString().split('T')[0];

  // Construcción de parámetros
  const params = new URLSearchParams();
  if (filters.user_id && filters.user_id !== 0) {
    params.append('user_id', filters.user_id.toString());
  }
  if (filters.init_date) params.append('init_date', filters.init_date);
  if (filters.end_date) params.append('end_date', filters.end_date);
  if (filters.codeAccount) params.append('codeAccount', filters.codeAccount);

  try {
    const response = await axios.get(
      `${API_URL}reports/account_statement/document/excel?${params.toString()}`,
      { responseType: 'blob' }
    );

    const blob = new Blob([response.data], {
      type: 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet',
    });
    const url = window.URL.createObjectURL(blob);
    const link = document.createElement('a');
    link.href = url;
    link.setAttribute('download', `REPORTE-ESTADO-DE-CUENTA-${date}.xlsx`);
    document.body.appendChild(link);
    link.click();

    setTimeout(() => {
      document.body.removeChild(link);
      window.URL.revokeObjectURL(url);
    }, 1000);

    return true;
  } catch (error: any) {
    if (error.response?.data instanceof Blob) {
      const errorText = await error.response.data.text();
      return JSON.parse(errorText);
    }
    return { message: 'Error inesperado' };
  }
}

export async function parseAxiosError(error: any): Promise<string> {
  if (!error.response) {
    return 'No hay conexión a internet';
  }

  try {
    const raw = await error.response.data.text?.();
    const data = JSON.parse(raw || '{}');

    if (data.message?.includes('ETIMEDOUT')) {
      return 'No hay conexión a internet';
    }

    return data.message || 'Error desconocido del servidor';
  } catch {
    return 'Error inesperado al interpretar la respuesta del servidor';
  }
}
